import script from "./sidebar-talking-points.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-talking-points.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__